<template>
<div v-if="loaded">
    <div class="d-flex justify-space-between align-center">
        <div class="subtitle-1 font-weight-regular over-title" @click="go">{{num}}. {{title}}</div>
        <v-btn fab text small v-if="!opener" @click="pleaseOpen">
            <v-icon color="accent" small>fa-plus</v-icon>
        </v-btn>
        <v-btn fab text small v-if="opener" @click="opener=false">
            <v-icon color="accent" small>fa-minus</v-icon>
        </v-btn>
    </div>
    
    <!-- 1 -->
    <div class="pr-0 pr-sm-12 pl-0 pl-sm-4 mt-3 d-flex" v-if="opener">
        <div class="pt-2 mr-3">
            <v-icon color="primary">fa-angle-right</v-icon>
        </div>
        <div style="width:100%">
            <v-text-field
                v-model="obj.c1.name"
                label="Contact name 1"
                outlined dense
                class="mt-n4 mt-sm-0">
            </v-text-field>
            <v-text-field
                v-model="obj.c1.org"
                :label="labeltit"
                outlined dense
                class="mt-n4 ">
            </v-text-field>
        </div>
    </div>

    <!-- 2 -->
    <div class="pr-0 pr-sm-12 pl-0 pl-sm-4 d-flex" v-if="opener">
        <div class="pt-2 mr-3">
            <v-icon color="primary">fa-angle-right</v-icon>
        </div>
        <div style="width:100%">
            <v-text-field
                v-model="obj.c2.name"
                label="Contact name 2"
                outlined dense
                class="mt-n4 mt-sm-0">
            </v-text-field>
            <v-text-field
                v-model="obj.c2.org"
                :label="labeltit"
                outlined dense
                class="mt-n4 ">
            </v-text-field>
        </div>
    </div>

    <!-- 3 -->
    <div class="pr-0 pr-sm-12 pl-0 pl-sm-4 d-flex" v-if="opener">
        <div class="pt-2 mr-3">
            <v-icon color="primary">fa-angle-right</v-icon>
        </div>
        <div style="width:100%">
            <v-text-field
                v-model="obj.c3.name"
                label="Contact name 3"
                outlined dense
                class="mt-n4 mt-sm-0">
            </v-text-field>
            <v-text-field
                v-model="obj.c3.org"
                :label="labeltit"
                outlined dense
                class="mt-n4 ">
            </v-text-field>
        </div>
    </div>

    <!-- 4 -->
    <div class="pr-0 pr-sm-12 pl-0 pl-sm-4 d-flex" v-if="opener">
        <div class="pt-2 mr-3">
            <v-icon color="primary">fa-angle-right</v-icon>
        </div>
        <div style="width:100%">
            <v-text-field
                v-model="obj.c4.name"
                label="Contact name 4"
                outlined dense
                class="mt-n4 mt-sm-0">
            </v-text-field>
            <v-text-field
                v-model="obj.c4.org"
                :label="labeltit"
                outlined dense
                class="mt-n4 ">
            </v-text-field>
        </div>
    </div>

    <!-- 5 -->
    <div class="pr-0 pr-sm-12 pl-0 pl-sm-4 d-flex" v-if="opener">
        <div class="pt-2 mr-3">
            <v-icon color="primary">fa-angle-right</v-icon>
        </div>
        <div style="width:100%">
            <v-text-field
                v-model="obj.c5.name"
                label="Contact name 5"
                outlined dense
                class="mt-n4 mt-sm-0">
            </v-text-field>
            <v-text-field
                v-model="obj.c5.org"
                :label="labeltit"
                outlined dense
                class="mt-n4 ">
            </v-text-field>
        </div>
    </div>

    <div class="pr-0 pr-sm-12 pl-0 pl-sm-4 text-right mt-n2 mb-4" v-if="opener">
        <v-btn text class="info--text" @click="opener=false" :disabled="sending">close</v-btn>
        <v-btn depressed class="accent" @click="send" :disabled="sending">save</v-btn>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        loaded: false,
        obj: null,
        opener: false,
        equality: true,
        sending: false
    }),
    props: ['num', 'title', 'model', 'labeltit', 'factoralia', 'division', 'pointer', 'close'],
    mounted() {
        this.obj = JSON.parse(JSON.stringify(this.model));
        this.loaded = true;
    },
    watch: {
        close() {
            this.opener = false;
            this.sending = false;
        }
    },
    methods: {
        go() {
            this.opener = !this.opener;
            this.$emit('go');
        },
        pleaseOpen() {
            this.opener = true;
        },
        send() {
            this.sending = true;
            this.$emit('save', {division: this.division, pointer: this.num, content: this.obj})
        }
    }
}
</script>

<style scoped>
    .over-title {
        cursor: pointer;
        width: 100%;
    }
    .over-title:hover {
        color: red;
    }
</style>